import * as actionType from "./notificationActions";
import { ApiGateWay } from "../../../ApiGateWay/ApiGateWay";
import { Config } from "../../../config/config";
const config = JSON.parse(Config);
const apiInterface4 = config["api4"];

let notifications = [];

export function getNotifications() {
  return ApiGateWay.newSimpleGet(apiInterface4 + "/api/getNotificationByUser")
    .then((result) => {
      if (Array.isArray(result)) {
        notifications = [...result];
      }
      return notifications;
    })
    .catch((e) => {
      console.log("Error while fetching notifications");
      console.log(e);
      return notifications;
    });
}
export const getNotificationsByRefId = (refId) => async (dispatch) => {
  return ApiGateWay.newSimpleGet(
    apiInterface4 + "/api/asyncTaskStatus/" + refId
  )
    .then((result) => {
      if (!!result.status) {
        dispatch(
          selectedNotification({
            showModal: true,
            notificationErrorList: result.status.split(","),
          })
        );
      }
    })
    .catch((e) => {
      console.log("Error while fetching notifications error list");
      console.log(e);
    });
};

export const selectedNotification = (data) => ({
  type: actionType.SELECTED_NOTIFICATION,
  payload: data,
});
